import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';
import ReCAPTCHA from 'react-google-recaptcha';

export const List = styled.ul`
  border: 1px solid ${COLORS.BLACK_BOLD};
  margin: 0 -15px;
  min-height: 65px;
  border-width: 1px 0;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 15px auto 0;
    width: 100%;
    border: 0;
  }
`;

export const RecaptchaWrapper = styled.div`
  max-width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  opacity: .5;
`;

export const Recaptcha = styled(ReCAPTCHA)`
  transform-origin: 0 0;
  transform: scale(0.8) translateX(10%);
`;

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0 15px;

  @media (min-width ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
  }
`;

export const SubTitle = styled.p`
  text-transform: uppercase;
  font-size: 15px;
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.BLACK_BOLD};
  margin-bottom: 14px;
`;